import { TenantEntity } from '../TenantEntity'

export class BillPayment extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'BillPayment'
  }
  // -------------------------------------非数据库字段

  // 保存付款申请时，后端需要的辅助参数
  get params() {
    return this._data.params
  }
  set params(params) {
    this._data.params = params || {}
  }
  // 新增付款申请时费用集合
  get mapCharge() {
    return this._data.mapCharge
  }
  set mapCharge(mapCharge) {
    this._data.mapCharge = mapCharge || []
  }
  // 更新付款申请时新增的费用
  get chargesAdded() {
    return this._data.chargesAdded
  }
  set chargesAdded(chargesAdded) {
    this._data.chargesAdded = chargesAdded || []
  }
  // 更新付款申请时时移除的费用
  get chargesRemoved() {
    return this._data.chargesRemoved
  }
  set chargesRemoved(chargesRemoved) {
    this._data.chargesRemoved = chargesRemoved || []
  }

  // ----------------------------------数据库字段
  get billPaymentId() {
    return this._data.billPaymentId
  }
  set billPaymentId(billPaymentId) {
    this._data.billPaymentId = billPaymentId
  }
  get billPaymentNo() {
    return this._data.billPaymentNo
  }
  set billPaymentNo(billPaymentNo) {
    this._data.billPaymentNo = billPaymentNo
  }
  get jobNo() {
    return this._data.jobNo
  }
  set jobNo(jobNo) {
    this._data.jobNo = jobNo
  }
  get ywType() {
    return this._data.ywType
  }
  set ywType(ywType) {
    this._data.ywType = ywType || 0
  }
  get se() {
    return this._data.se
  }
  set se(se) {
    this._data.se = se || false
  }
  get si() {
    return this._data.si
  }
  set si(si) {
    this._data.si = si || false
  }
  get ae() {
    return this._data.ae
  }
  set ae(ae) {
    this._data.ae = ae || false
  }
  get ai() {
    return this._data.ai
  }
  set ai(ai) {
    this._data.ai = ai || false
  }
  get payType() {
    return this._data.payType
  }
  set payType(payType) {
    this._data.payType = payType || 0
  }
  get accountId() {
    return this._data.accountId
  }
  set accountId(accountId) {
    this._data.accountId = accountId || 0
  }
  get settlementAgentId() {
    return this._data.settlementAgentId
  }
  set settlementAgentId(settlementAgentId) {
    this._data.settlementAgentId = settlementAgentId || 0
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency
  }
  get amount() {
    return this._data.amount
  }
  set amount(amount) {
    this._data.amount = amount || 0.0
  }
  get rate() {
    return this._data.rate
  }
  set rate(rate) {
    this._data.rate = rate || 0.0
  }
  get state() {
    return this._data.state
  }
  set state(state) {
    this._data.state = state || 0
  }
  get deadline() {
    return this._data.deadline
  }
  set deadline(deadline) {
    this._data.deadline = deadline
  }
  get remark() {
    return this._data.remark
  }
  set remark(remark) {
    this._data.remark = remark
  }
  get replaceInvoiceRemark() {
    return this._data.replaceInvoiceRemark
  }
  set replaceInvoiceRemark(replaceInvoiceRemark) {
    this._data.replaceInvoiceRemark = replaceInvoiceRemark
  }
  get inputBy() {
    return this._data.inputBy
  }
  set inputBy(inputBy) {
    this._data.inputBy = inputBy || 0
  }
  get inputByDep() {
    return this._data.inputByDep
  }
  set inputByDep(inputByDep) {
    this._data.inputByDep = inputByDep || 0
  }
  get inputDate() {
    return this._data.inputDate
  }
  set inputDate(inputDate) {
    this._data.inputDate = inputDate
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId || 0
  }
  get clearingState() {
    return this._data.clearingState
  }
  set clearingState(clearingState) {
    this._data.clearingState = clearingState || 0
  }
  get costInvoiceNo() {
    return this._data.costInvoiceNo
  }
  set costInvoiceNo(costInvoiceNo) {
    this._data.costInvoiceNo = costInvoiceNo
  }
  get chineseAmount() {
    return this._data.chineseAmount
  }
  set chineseAmount(chineseAmount) {
    this._data.chineseAmount = chineseAmount
  }
  get paymentType() {
    return this._data.paymentType
  }
  set paymentType(paymentType) {
    this._data.paymentType = paymentType
  }
  get advance() {
    return this._data.advance
  }
  set advance(advance) {
    this._data.advance = advance || false
  }
  get customerId() {
    return this._data.customerId
  }
  set customerId(customerId) {
    this._data.customerId = customerId || 0
  }
  get businessVerifier() {
    return this._data.businessVerifier
  }
  set businessVerifier(businessVerifier) {
    this._data.businessVerifier = businessVerifier || 0
  }
  get businessVerifyDate() {
    return this._data.businessVerifyDate
  }
  set businessVerifyDate(businessVerifyDate) {
    this._data.businessVerifyDate = businessVerifyDate
  }
  get financeVerifier() {
    return this._data.financeVerifier
  }
  set financeVerifier(financeVerifier) {
    this._data.financeVerifier = financeVerifier || 0
  }
  get financeVerifyDate() {
    return this._data.financeVerifyDate
  }
  set financeVerifyDate(financeVerifyDate) {
    this._data.financeVerifyDate = financeVerifyDate
  }
  get currencyAmount() {
    return this._data.currencyAmount
  }
  set currencyAmount(currencyAmount) {
    this._data.currencyAmount = currencyAmount
  }
  get ourTitle() {
    return this._data.ourTitle
  }
  set ourTitle(ourTitle) {
    this._data.ourTitle = ourTitle
  }
  get buyerBank() {
    return this._data.buyerBank
  }
  set buyerBank(buyerBank) {
    this._data.buyerBank = buyerBank
  }
  get buyerBankAccount() {
    return this._data.buyerBankAccount
  }
  set buyerBankAccount(buyerBankAccount) {
    this._data.buyerBankAccount = buyerBankAccount
  }
  get settleDepartmentPrefix() {
    return this._data.settleDepartmentPrefix
  }
  set settleDepartmentPrefix(settleDepartmentPrefix) {
    this._data.settleDepartmentPrefix = settleDepartmentPrefix
  }
  get recordType() {
    return this._data.recordType
  }
  set recordType(recordType) {
    this._data.recordType = recordType
  }
  get attachments() {
    return this._data.attachments
  }
  set attachments(attachments) {
    this._data.attachments = attachments
  }
  get rateByCharge() { // 按费用汇率创建
    return this._data.rateByCharge
  }
  set rateByCharge(rateByCharge) {
    this._data.rateByCharge = rateByCharge || false
  }
  get payByBillingRate() { // 按账单汇率付款
    return this._data.payByBillingRate
  }
  set payByBillingRate(payByBillingRate) {
    this._data.payByBillingRate = payByBillingRate || false
  }
  get userDefinedField1() {
    return this._data.userDefinedField1
  }
  set userDefinedField1(userDefinedField1) {
    this._data.userDefinedField1 = userDefinedField1
  }
  get userDefinedField2() {
    return this._data.userDefinedField2
  }
  set userDefinedField2(userDefinedField2) {
    this._data.userDefinedField2 = userDefinedField2
  }
  get userDefinedField3() {
    return this._data.userDefinedField3
  }
  set userDefinedField3(userDefinedField3) {
    this._data.userDefinedField3 = userDefinedField3
  }
  get userDefinedField4() {
    return this._data.userDefinedField4
  }
  set userDefinedField4(userDefinedField4) {
    this._data.userDefinedField4 = userDefinedField4
  }
  get userDefinedField5() {
    return this._data.userDefinedField5
  }
  set userDefinedField5(userDefinedField5) {
    this._data.userDefinedField5 = userDefinedField5
  }
  get userDefinedField6() {
    return this._data.userDefinedField6
  }
  set userDefinedField6(userDefinedField6) {
    this._data.userDefinedField6 = userDefinedField6
  }
  get wechatPaymentDepartment() {
    return this._data.wechatPaymentDepartment
  }
  set wechatPaymentDepartment(wechatPaymentDepartment) {
    this._data.wechatPaymentDepartment = wechatPaymentDepartment
  }
  get wechatPaymentCompany() {
    return this._data.wechatPaymentCompany
  }
  set wechatPaymentCompany(wechatPaymentCompany) {
    this._data.wechatPaymentCompany = wechatPaymentCompany
  }
  get wechatPaymentMethod() {
    return this._data.wechatPaymentMethod
  }
  set wechatPaymentMethod(wechatPaymentMethod) {
    this._data.wechatPaymentMethod = wechatPaymentMethod
  }
  get wechatPaymentFeeType() {
    return this._data.wechatPaymentFeeType
  }
  set wechatPaymentFeeType(wechatPaymentFeeType) {
    this._data.wechatPaymentFeeType = wechatPaymentFeeType
  }
  get wechatWaterNotifier() {
    return this._data.wechatWaterNotifier
  }
  set wechatWaterNotifier(wechatWaterNotifier) {
    this._data.wechatWaterNotifier = wechatWaterNotifier
  }
  // ===========================扩展属性===========================
  get currentJobNo() {
    return this._data.currentJobNo
  }
  set currentJobNo(currentJobNo) {
    this._data.currentJobNo = currentJobNo
  }
  get paymentInstructions() {
    return this._data.paymentInstructions
  }
  set paymentInstructions(paymentInstructions) {
    this._data.paymentInstructions = paymentInstructions
  }
  get invoiceNumber() {
    return this._data.invoiceNumber
  }
  set invoiceNumber(invoiceNumber) {
    this._data.invoiceNumber = invoiceNumber
  }
  get paymentDepartment() {
    return this._data.paymentDepartment
  }
  set paymentDepartment(paymentDepartment) {
    this._data.paymentDepartment = paymentDepartment
  }
  get paymentCompany() {
    return this._data.paymentCompany
  }
  set paymentCompany(paymentCompany) {
    this._data.paymentCompany = paymentCompany
  }
  get paymentMethod() {
    return this._data.paymentMethod
  }
  set paymentMethod(paymentMethod) {
    this._data.paymentMethod = paymentMethod
  }
  get paymentFeeType() {
    return this._data.paymentFeeType
  }
  set paymentFeeType(paymentFeeType) {
    this._data.paymentFeeType = paymentFeeType
  }
  get waterNotifier() {
    return this._data.waterNotifier
  }
  set waterNotifier(waterNotifier) {
    this._data.waterNotifier = waterNotifier
  }
  get syncInvoiceAttachment() {
    return this._data.syncInvoiceAttachment
  }
  set syncInvoiceAttachment(syncInvoiceAttachment) {
    this._data.syncInvoiceAttachment = syncInvoiceAttachment
  }
}
